
<div style="padding-left:14%;padding-right:14%;padding-top: 3%;line-height: 25px;font-size: 19px">
    <div class="row">
            <img src="./assets/img/doktorslogo.png" style="height:60px" />
            <h3 style="float: right;margin-top: 20px" align="center">Term and Conditions</h3>
    </div>
  <hr />
  <p style="margin-top: 60px">
    This app is operated by<b><span style="color:green"> MAVIN GLOBUS</span></b>.
    Throughout this site the terms “we”, “us” and “our” refer to as
    <b><span class="fontgreen">MAVIN GLOBUS</span></b>.
    <b><span class="fontgreen">MAVIN GLOBUS</span></b> offers the app
    including all information, tools and services available from this app to
    you, the user, conditioned upon your acceptance of all terms, conditions,
    policies and notices stated here. By downloading our app of making paid
    appointment form our app or use services provided by the app you agree to be
    bound by the following terms and conditions
    <u>(“Terms of Services”, “Terms”)</u>, including those additional terms and
    conditions and policies referenced herein and/or available by hyperlink.
    These Terms of Service apply to all users of the app, including without
    limitation users, members, and/ or contributors of content. Please read
    these Terms of Service carefully before using our app. By accessing or using
    any part of the app, you agree to be bound by these Terms of Service. If you
    do not agree to all the terms and conditions of this agreement, then you may
    not access the app or use any services. If these Terms of Service are
    considered an offer, acceptance is expressly limited to these Terms of
    Service. Any new features or tools which are added to the current store
    shall also be subject to the Terms of Service. You can review the most
    current version of the Terms of Service at any time on this page. We reserve
    the right to update, change or replace any part of these Terms of Service by
    posting updates and/or changes to our website. It is your responsibility to
    check this page periodically for changes. Your continued use of or access to
    the website following the posting of any changes constitutes acceptance of
    those changes.</p>
    
    <div style="padding:10px;background: #efefef;margin-top: 15px">
 <b>SECTION 1 - ONLINE APPOINTMENT </b>
</div>
    <p>By agreeing to these Terms of Service, you represent that you are at least
    the age of majority in your state or province of residence, or that you are
    the age of majority in your state or province of residence and you have
    given us your consent to allow any of your minor dependents to use this app.
    You may not use our products for any illegal or unauthorized purpose nor may
    you, in the use of the Service, violate any laws in your jurisdiction
    (including but not limited to copyright laws) You must not transmit any
    worms or viruses or any code of a destructive nature. A breach or violation
    of any of the Terms will result in an immediate termination of your
    Services.</p>
    
    <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 2 - GENERAL CONDITIONS</b>
    </div>
    <p>
    We reserve the right to refuse service to anyone for any reason at any time.
    You understand that your content (not including credit card information),
    may be transferred unencrypted and involve (a) transmissions over various
    networks; and (b) changes to conform and adapt to technical requirements of
    connecting networks or devices. Credit card information is always encrypted
    during transfer over networks. You agree not to reproduce, duplicate, copy,
    sell, resell or exploit any portion of the Service, use of the Service, or
    access to the Service or any contact on the app through which the service is
    provided, without express written permission by us. The headings used in
    this agreement are included for convenience only and will not limit or
    otherwise affect these Terms.</p>
    
    <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 3 - ACCURACY, COMPLETENESS AND TIMELINESS OF INFORMATION </b>
</div>
    <p>We are not responsible if information made available on this app is not
    accurate, complete or current. The material on this app is provided for
    general information only and should not be relied upon or used as the sole
    basis for making decisions without consulting primary, more accurate, more
    complete or more timely sources of information. Any reliance on the material
    on this app is at your own risk. This app contains the information of
    doctors and their schedules, also Diagnostic centers. We reserve the right
    to modify the contents inside our app at any time, but we have no obligation
    to update any information on our app. You agree that it is your
    responsibility to monitor changes to our app.</p>
    <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 4 - MODIFICATIONS TO THE SERVICE AND PRICES </b>
    </div>
    <p>Prices of making appointment through our app are subject to change without
    notice. We reserve the right at any time to modify or discontinue the
    Service (or any part or content thereof) without notice at any time. We
    shall not be liable to you or to any third-party for any modification, price
    change, suspension or discontinuance of the Service.</p>
    
    <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 5 – DOCTOR ATTENDING TIME</b>
    </div>
    <p>We do not warrant that the time and availability information obtained by you
    will meet your accurate and always correct, some time doctor has to attend
    some Emergency cases due to which you may receive difference in your
    scheduled appointment time.</p>
    <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 6 - ACCURACY OF BILLING AND ACCOUNT INFORMATION </b>
</div>
    <p>We and the appointed doctor by the user have the right to refuse any
    appointment you place with us. These restrictions may include appointment
    placed by or under the same customer account, the same credit card, and/or
    orders that use the same billing. In the event that we make a change to or
    cancel an appointment, we may attempt to notify you by contacting the e-mail
    and/or phone number provided at the time the appointment was made. You agree
    to provide patient name, age and his relation to the account. You agree to
    promptly update your account and other information, including your phone
    number, email address, medical conditions, reports which are completely safe
    and can be accessed from authenticated user only.</p>
    <div style="padding:10px;background: #efefef;margin-top: 15px">
   <b> SECTION 7 - PERSONAL INFORMATION </b>
</div>
   <p> Our Privacy Policy governs your submission of personal
    information through the app.</p>
    <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 8 - ERRORS, INACCURACIES AND OMISSIONS </b>
</div>
    <p>
    Occasionally there may be information on our that may be inaccurate like
    doctor week availability and their timings or daily limit, we are
    responsible for none of this information as this is being filled by the
    doctor itself not by us.</p>
    <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 9 - PROHIBITED USES </b>
    </div>
    <p>
    In addition to other prohibitions as set forth in the Terms of Service, you
    are prohibited from using the app and its data: (a) for any unlawful
    purpose; (b) to solicit others to perform or participate in any unlawful
    acts; (c) to violate any international, federal, provincial or state
    regulations, rules, laws, or local ordinances; (d) to infringe upon or
    violate our intellectual property rights or the intellectual property rights
    of others; (e) to harass, abuse, insult, harm, defame, slander, disparage,
    intimidate, or discriminate based on gender, sexual orientation, religion,
    ethnicity, race, age, national origin, or disability; (f) to submit false or
    misleading information; (g) to upload or transmit viruses or any other type
    of malicious code that will or may be used in any way that will affect the
    functionality or operation of the Service or of any related website, other
    websites, or the Internet; (h) to collect or track the personal information
    of others; (i) to spam, phish, pharm, pretext, spider, crawl, or scrape; (j)
    for any obscene or immoral purpose. We reserve the right to terminate your
    use of the Service or any related website or app for violating any of the
    prohibited uses.</p>
    <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 10 - DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY </b>
</div>
    <p>
    We do not guarantee, represent or warrant that your use of our service will
    be uninterrupted, timely or error-free. We do not warrant that the results
    that may be obtained from the use of the service will be accurate or
    reliable. You agree that from time to time we may remove the service for
    indefinite periods of time or cancel the service at any time, without notice
    to you. You agree that any time we can change the free appointment count of
    a new account. In no case shall MAVIN GLOBUS, our directors, officers,
    employees, affiliates, agents, contractors, interns, service providers or
    licensors be liable for any injury, loss, claim, or any direct, indirect,
    incidental, punitive, special, or consequential damages of any kind,
    including, without limitation lost profits, loss of data, replacement costs,
    or any similar damages, whether based in contract, tort (including
    negligence), strict liability or otherwise, arising from your use of any of
    the service or any products procured using the service, or for any other
    claim related in any way to your use of the service or any product,
    including, but not limited to, any errors or omissions in any content, or
    any loss or damage of any kind incurred as a result of the use of the
    service or any content (or product) posted, transmitted, or otherwise made
    available via the service, even if advised of their possibility. Because
    some states or jurisdictions do not allow the exclusion or the limitation of
    liability for consequential or incidental damages, in such states or
    jurisdictions, our liability shall be limited to the maximum extent
    permitted by law.</p>
    <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 11 – INDEMNIFICATION </b>
</div>
    <p>
    You agree to indemnify, defend and hold harmless MAVIN GLOBUS and our
    parent, subsidiaries, affiliates, partners, officers, directors, agents,
    contractors, licensors, service providers, subcontractors, suppliers,
    interns and employees, harmless from any claim or demand, including
    reasonable attorneys’ fees, made by any third-party due to or arising out of
    your breach of these Terms of Service or the documents they incorporate by
    reference, or your violation of any law or the rights of a third-party.</p>
    
    <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 12 – SEVERABILITY</b>
    </div>
    <p>
    In the event that any provision of these Terms of Service is determined to
    be unlawful, void or unenforceable, such provision shall nonetheless be
    enforceable to the fullest extent permitted by applicable law, and the
    unenforceable portion shall be deemed to be severed from these Terms of
    Service, such determination shall not affect the validity and enforceability
    of any other remaining provisions.</p>
    <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 13 – TERMINATION </b>
</div>
    <p>
    The obligations and liabilities of the parties incurred prior to the
    termination date shall survive the termination of this agreement for all
    purposes. These Terms of Service are effective unless and until terminated
    by either you or us. You may terminate these Terms of Service at any time by
    notifying us that you no longer wish to use our Services, or when you cease
    using our app/software. If in our sole judgment you fail, or we suspect that
    you have failed, to comply with any term or provision of these Terms of
    Service, we also may terminate this agreement at any time without notice and
    you will remain liable for all amounts due up to and including the date of
    termination; and/or accordingly may deny you access to our Services (or any
    part thereof).</p>
    <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 14 - ENTIRE AGREEMENT</b>
</div>
    <p>
    The failure of us to exercise or enforce any right or provision of these
    Terms of Service shall not constitute a waiver of such right or provision.
    These Terms of Service and any policies or operating rules posted by us on
    this site or in respect to The Service constitutes the entire agreement and
    understanding between you and us and govern your use of the Service,
    superseding any prior or contemporaneous agreements, communications and
    proposals, whether oral or written, between you and us (including, but not
    limited to, any prior versions of the Terms of Service). Any ambiguities in
    the interpretation of these Terms of Service shall not be construed against
    the drafting party.</p>
    <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 15 - GOVERNING LAW </b>
</div>
    <p>
    These Terms of Service and any separate agreements whereby we provide you
    Services shall be governed by and construed in accordance with the laws of
    India and jurisdiction of Jaipur, Rajasthan.</p>
    <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 16 - CHANGES TO TERMS OF SERVICE </b>
</div>
    <br />
    <p>
    You can review the most current version of the Terms of Service at any time
    at this page. We reserve the right, at our sole discretion, to update,
    change or replace any part of these Terms of Service by posting updates and
    changes to our app. It is your responsibility to check our app periodically
    for changes. Your continued use of or access to our app or the Service
    following the posting of any changes to these Terms of Service constitutes
    acceptance of those changes.</p>
    <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 17 - CONTACT INFORMATION </b>
    </div>
    <p>
    Questions about the Terms of
    Service should be sent to us at <a href="mailto:info@mavinglobus.com">info@mavinglobus.com</a></p>
  
  </div>


